<template>
  <div class="video-crawler-testing-container">
    <div class="video-crawler-testing">
      <h5>Video Crawler Testing</h5>
      <label>ทดสอบการใช้งาน Crawler จาก URL ของหน้าเว็บที่มีตัวเล่นวิดีโอ</label>
      <FormGroup>
        <div class="row">
          <div class="col-md-6 form-same-line">
            <TextInput
              :name="'url'"
              :placeholder="'e.g. https://byteark.com/media/sample_video'"
              :value="url"
              @change="onChange" />
            <div class="ml-4 float-right" :class="{ '--loading': state.isLoading }">
              <Button @click="onCreateCrawlerPreview">
                <span>{{ state.isLoading ? '' : 'Test' }}</span>
                <span class="spinner-border spinner-border-sm" role="status" v-if="state.isLoading" />
              </Button>
            </div>
          </div>
        </div>
      </FormGroup>
      <div class="video-crawler-testing__results" v-if="testResult">
        <VideoCrawlerTestResultTable :testResult="testResult" />
      </div>
      <div class="video-crawler-testing__results" v-else-if="state.isError">
        <div class="text-danger">
          *** Invalid URL ***
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';

import Button from '@/form/Button.vue';
import FormGroup from '@/form/FormGroup.vue';
import TextInput from '@/form/TextInput.vue';
import VideoCrawlerTestResultTable from '@/project/videoCrawler/VideoCrawlerTestResultTable.vue';

import { createCrawlerPreview } from '@/project/api';

export default {
  props: ['project', 'crawler', 'mapPayloadToCrawlAttributes', 'setReadyToSave'],
  components: {
    Button,
    FormGroup,
    TextInput,
    VideoCrawlerTestResultTable,
  },
  data() {
    return {
      url: '',
      testResult: null,
      state: {
        isLoading: false,
        isError: false,
      },
    };
  },
  computed: {
    resultIsEmpty() {
      return _.isEmpty(this.testResult);
    },
    projectId() {
      return this.project.projectId;
    },
  },
  methods: {
    onChange(event) {
      const { value } = event.target;
      this.url = value;
    },
    async onCreateCrawlerPreview() {
      this.mapPayloadToCrawlAttributes();
      this.state.isLoading = true;
      this.state.isError = false;
      this.crawler.mediaReferer = this.url;
      try {
        const response = await createCrawlerPreview(this.projectId, this.crawler);
        this.testResult = response.data.crawlerResult;
        this.state.isLoading = false;
        this.setReadyToSave();
      } catch (e) {
        this.state.isLoading = false;
        this.state.isError = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.--loading {
  opacity: .5;
  pointer-events: none;
}

.form-same-line {
  display: flex;
  input {
    flex: 0 0 auto;
  }
}
</style>
